// extracted by mini-css-extract-plugin
module.exports = {"participants":"Participants_participants__1yOho","add":"Participants_add__1M86N"};